import type { FC } from "react";

import { displayOutcomeName } from "components/outcomes/helpers";
import { OutcomeType } from "components/server-types";
import { t } from "i18n/i18n";
import { OutcomeChip } from "mds/components/OutcomeChip";

type OutcomeChipListProps = {
  size?: "s" | "m";
  outcomes: OutcomeType[];
  scoreMap?: Record<string, number>;
  getOutcomeUrl: (outcome: OutcomeType) => string;
  selectedOutcomeId?: string;
};

export const OutcomeChipList: FC<OutcomeChipListProps> = ({
  size = "s",
  outcomes,
  scoreMap = {},
  getOutcomeUrl,
  selectedOutcomeId,
}) => {
  return (
    <ol aria-label={t("glossary.outcomes")} className="my-2 flex flex-wrap items-center">
      {outcomes.map((outcome) => (
        <li key={outcome.id}>
          <OutcomeChip
            className="mx-2 my-1"
            score={scoreMap[outcome.id] ?? undefined}
            selected={selectedOutcomeId === outcome.id}
            size={size}
            title={displayOutcomeName(outcome)}
            to={getOutcomeUrl(outcome)}
          />
        </li>
      ))}
    </ol>
  );
};
